"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagnifyingGlass = void 0;
var React = require("react");
var MagnifyingGlass = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement("svg", { height: "124px", width: "124px", version: "1.1", viewBox: "0 0 124 124", xmlns: "http://www.w3.org/2000/svg", style: style },
        React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeLinecap: "round", strokeWidth: "1", transform: "translate(-658.000000, -358.000000)" },
            React.createElement("g", { strokeWidth: "4", transform: "translate(204.000000, 164.000000)" },
                React.createElement("g", { transform: "translate(224.000000, 156.000000)" },
                    React.createElement("g", { transform: "translate(40.000000, 40.000000)" },
                        React.createElement("g", { transform: "translate(192.000000, 0.000000)" },
                            React.createElement("path", { d: "M120,120 L95.1724138,95.1724138", stroke: "#00B5E1" }),
                            React.createElement("circle", { cx: "49.6551724", cy: "49.6551724", r: "49.6551724", stroke: "#002C8B" }),
                            React.createElement("path", { d: "M17.5862069,41.3793103 C20.6896552,29.7931034 29.7931034,20.6896552 41.3793103,17.5862069", stroke: "#00B5E1" }))))))));
};
exports.MagnifyingGlass = MagnifyingGlass;
//# sourceMappingURL=MagnifyingGlass.js.map